import React from 'react';
import { Phone, Mail, MessageCircle, Globe, Facebook, Instagram } from 'lucide-react';

const TravelCertificate = () => {
  const data = {
    nombre: "GUSTAVO AGUIAR",
    certificado: "1386043",
    fechaNacimiento: "07-11-1988 (37 años)",
    documento: "AAF282395",
    origen: "Argentina",
    destino: "Colombia",
    salida: "26-03-2026",
    retorno: "26-12-2026",
    plan: "Plan Esencial",
    totalAsistencia: "60,000 USD"
  };

  const ServiceItem = ({ label, value }) => (
    <div className="flex justify-between border-b border-gray-100 py-1 text-[10px]">
      <span className="text-gray-700 uppercase font-medium">{label}</span>
      <span className="font-bold text-blue-900">{value}</span>
    </div>
  );

  return (
    <div className="max-w-4xl mx-auto my-10 bg-white shadow-2xl p-8 font-sans text-slate-800 relative overflow-hidden print:shadow-none print:my-0">
      
      {/* Marca de agua de fondo (Simulada) */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none flex flex-wrap gap-10 rotate-[-15deg] scale-150">
        {[...Array(20)].map((_, i) => (
          <span key={i} className="text-4xl font-bold italic">Seguro para Viaje</span>
        ))}
      </div>

      <div className="relative z-10">
        {/* Header */}
        <div className="flex justify-between items-start mb-6">
          <div className="flex items-center gap-2">
            <div className="bg-blue-900 p-2 rounded-lg">
              <Globe className="text-white w-8 h-8" />
            </div>
            <div>
              <h1 className="text-2xl font-black text-blue-900 leading-none">
                Seguro <br /> <span className="text-pink-500 text-lg">para</span> <span className="text-pink-500">Viaje</span>
              </h1>
            </div>
          </div>
        </div>

        {/* User Info Grid */}
        <div className="grid grid-cols-2 gap-x-12 gap-y-2 mb-8 text-xs">
          <div className="space-y-1">
            <p><span className="text-blue-900 font-bold">Nombre:</span> <span className="uppercase">{data.nombre}</span></p>
            <p><span className="text-blue-900 font-bold">Certificado No.</span> {data.certificado}</p>
            <p><span className="text-blue-900 font-bold">Fecha de nacimiento:</span> {data.fechaNacimiento}</p>
            <p><span className="text-blue-900 font-bold">DNI / Pasaporte:</span> {data.documento}</p>
          </div>
          <div className="space-y-1">
            <p><span className="text-blue-400 font-bold">Origen:</span> {data.origen}</p>
            <p><span className="text-blue-400 font-bold">Destino:</span> {data.destino}</p>
            <p><span className="text-blue-400 font-bold">Salida:</span> {data.salida}</p>
            <p><span className="text-blue-400 font-bold">Retorno:</span> {data.retorno}</p>
          </div>
        </div>

        {/* Contact Banner */}
        <div className="bg-blue-50 border-y-2 border-blue-100 p-4 mb-8">
          <h3 className="text-blue-900 font-bold text-center mb-3">¿Necesitas solicitar asistencia durante tu viaje?</h3>
          <div className="flex justify-around items-center text-[10px] text-blue-900">
            <div className="flex items-center gap-1 font-bold">
              <MessageCircle className="w-4 h-4 text-green-500 fill-green-500" /> (+1) 2018016266
            </div>
            <div className="flex items-center gap-1 font-bold">
              <Phone className="w-4 h-4 fill-blue-900" /> (+34) 627 120 534
            </div>
            <div className="flex items-center gap-1 font-bold lowercase underline">
              <Mail className="w-4 h-4 fill-blue-900 text-white" /> contacto@traveler-assistance.com
            </div>
          </div>
        </div>

        {/* Plan Header */}
        <div className="flex justify-between items-end border-b-2 border-blue-900 mb-4 pb-1">
          <h3 className="text-blue-900 font-black text-lg">Detalle de tus servicios</h3>
          <div className="text-right">
            <span className="text-blue-900 font-black text-xl italic">{data.plan}</span>
            <span className="text-xs ml-2">Total de asistencia <span className="font-bold text-blue-900 text-lg">{data.totalAsistencia}</span></span>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-2 gap-x-10 gap-y-6">
          
          {/* Column 1 */}
          <div className="space-y-4">
            <section>
              <h4 className="text-blue-900 font-black text-[11px] mb-2 uppercase italic border-l-4 border-pink-500 pl-2">Servicios Médicos</h4>
              <ServiceItem label="Atención médica por accidente" value="30,000 USD" />
              <ServiceItem label="Atención Médica Por Enfermedad (Incluye Covid)" value="30,000 USD" />
              <ServiceItem label="Línea de atención 24/7" value="Incluido" />
              <ServiceItem label="Telemedicina" value="Incluido" />
              <ServiceItem label="Hospitalización" value="Incluido" />
              <ServiceItem label="Medicamentos por atención ambulatoria" value="400 USD" />
              <ServiceItem label="Urgencias por enfermedad preexistente" value="500 USD" />
            </section>

            <section>
              <h4 className="text-blue-900 font-black text-[11px] mb-2 uppercase italic border-l-4 border-pink-500 pl-2">Servicios de Traslado</h4>
              <ServiceItem label="Traslado de emergencia" value="Incluido" />
              <ServiceItem label="Repatriación sanitaria" value="30,000 USD" />
              <ServiceItem label="Repatriación funeraria" value="30,000 USD" />
              <ServiceItem label="Traslado de un familiar" value="600 USD" />
            </section>
          </div>

          {/* Column 2 */}
          <div className="space-y-4">
            <section>
              <h4 className="text-blue-900 font-black text-[11px] mb-2 uppercase italic border-l-4 border-pink-500 pl-2">Servicios en Viaje</h4>
              <ServiceItem label="Pérdida de pasaporte" value="75 USD" />
              <ServiceItem label="Hotel por convalecencia monto máximo" value="1,000 USD" />
              <ServiceItem label="Extensión de hospedaje por Covid-19" value="1,500 USD" />
              <ServiceItem label="Compensación Por Invalidez O Muerte" value="15,000 USD" />
              <ServiceItem label="Rastreo de equipaje" value="Incluido" />
              <ServiceItem label="Pérdida de equipaje" value="100 USD" />
            </section>

            <section>
              <h4 className="text-blue-900 font-black text-[11px] mb-2 uppercase italic border-l-4 border-pink-500 pl-2">Servicios Legales</h4>
              <ServiceItem label="Envío y transferencia de fondos" value="1,000 USD" />
              <ServiceItem label="Transferencia de fondos para fianza legal" value="15,000 USD" />
              <ServiceItem label="Asistencia legal por accidente de tránsito" value="5,000 USD" />
              <ServiceItem label="Límite de edad" value="85 años" />
            </section>
          </div>
        </div>

        {/* Footer Info (Social Media) */}
        <div className="mt-12 flex justify-between items-center border-t pt-4">
            <div className="flex gap-4 items-center">
                <div className="flex items-center gap-1 text-[10px] text-blue-900 font-bold">
                    <Instagram size={14} /> @seguroparaviaje
                </div>
                <div className="flex items-center gap-1 text-[10px] text-blue-900 font-bold">
                    <Globe size={14} /> www.seguroparaviaje.com
                </div>
            </div>
            <div className="flex gap-4 items-center">
                <div className="flex items-center gap-1 text-[10px] text-blue-900 font-bold">
                    <Facebook size={14} /> seguroparaviaje
                </div>
                <div className="flex items-center gap-1 text-[10px] text-blue-900 font-bold">
                    <MessageCircle size={14} /> (+1) 2018016266
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default TravelCertificate;